export default __webpack_public_path__ + "static/media/whitepaper.faf0ad5c.jpg";